import styles from './index.module.scss'

export const Navs = (props: { onClick: () => void }) => {
  return <div className={styles.navs}>
    <img src='/assets/Monsoon.png' />
    <button className={styles.navButton} onClick={props.onClick} >Join Now</button>
  </div>
}